import React from "react";
import Modal from "react-bootstrap/Modal";

function ModalUI({
  show,
  handleClose,
  children,
  title,
  titleClass,
  size,
  zIndex,
  className,
}) {
  const containerStyles = {
    maxHeight: "95vh",
    overflowY: "auto",
    scrollbarWidth: "none",
    borderBottomLeftRadius: "6px",
    borderBottomRightRadius: "6px",
    zIndex: zIndex || 9999,
  };

  return (
    <Modal
      className={className}
      show={show}
      onHide={handleClose}
      size={size}
      style={containerStyles}
    >
      <div className="p-4 m-2">
        <div className="d-flex justify-content-between align-items-start">
          <h6 className={`${titleClass} mb-3`}>{title}</h6>
          <Modal.Header
            style={{ borderBottom: 0, padding: 0 }}
            closeButton
            className="rounded-5"
          />
        </div>

        {children}
      </div>
    </Modal>
  );
}

export default ModalUI;

// example {children} in AddNote.js

//  <Modal.Body className="px-4 mx-4" style={{paddingBlock: 0 }}>
//  <form onSubmit={formik.handleSubmit}>
//    <ShortTextInput
//      label="Title"
//      id="title"
//      value={formik.values.title}
//      onChange={formik.handleChange}
//    />
//    <ShortTextInput
//      label="Note"
//      id="note"
//      value={formik.values.note}
//      onChange={formik.handleChange}
//    />
//  </form>
//  </Modal.Body>

//  <Modal.Footer
//  className="justify-content-center border-0"
//  style={{ marginBottom: "30px" }}
//  >
//  <CustomButton type="submit" onClick={formik.handleSubmit}>
//    {loading ? "Loading..." : isEdit ? "Update" : "Add Note"}
//  </CustomButton>
//  </Modal.Footer>
